<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { computed } from 'vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { useMapGetter } from 'dashboard/composables/store';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';

// Rail toggle of the conversation header (CrmB): one square button that
// shows / hides the contact rail (teal-tinted when open), plus Copilot
// when the account has it.
const { updateUISettings } = useUISettings();

const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const showCopilotTab = computed(() => {
  const isCaptainEnabled = isFeatureEnabledonAccount.value(
    currentAccountId.value,
    FEATURE_FLAGS.CAPTAIN
  );
  const isCopilotEnabledGlobal =
    window.globalConfig.ENABLE_COPILOT.to_s !== 'false' &&
    window.globalConfig.ENABLE_COPILOT !== false;
  return isCaptainEnabled && isCopilotEnabledGlobal;
});

const { uiSettings } = useUISettings();
const isContactSidebarOpen = computed(
  () => uiSettings.value.is_contact_sidebar_open
);
const isCopilotPanelOpen = computed(
  () => uiSettings.value.is_copilot_panel_open
);

const toggleConversationSidebarToggle = () => {
  updateUISettings({
    is_contact_sidebar_open: !isContactSidebarOpen.value,
    is_copilot_panel_open: false,
  });
};

const handleCopilotSidebarToggle = () => {
  updateUISettings({
    is_contact_sidebar_open: false,
    is_copilot_panel_open: !isCopilotPanelOpen.value,
  });
};

const keyboardEvents = {
  'Alt+KeyO': {
    action: toggleConversationSidebarToggle,
  },
};
useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div class="flex items-center gap-1.5">
    <Button
      v-tooltip.bottom="$t('CONVERSATION.SIDEBAR.CONTACT')"
      icon="i-lucide-panel-right"
      size="sm"
      variant="ghost"
      color="slate"
      class="w-8 rounded-[7px]"
      :class="
        isContactSidebarOpen
          ? '!bg-n-solid-blue !text-n-blue-text'
          : 'bg-n-alpha-2'
      "
      @click="toggleConversationSidebarToggle"
    />
    <Button
      v-if="showCopilotTab"
      v-tooltip.bottom="$t('CONVERSATION.SIDEBAR.COPILOT')"
      icon="i-woot-captain"
      size="sm"
      variant="ghost"
      color="slate"
      class="w-8 rounded-[7px]"
      :class="
        isCopilotPanelOpen ? '!bg-n-solid-iris !text-n-iris-11' : 'bg-n-alpha-2'
      "
      @click="handleCopilotSidebarToggle"
    />
  </div>
</template>
